export class CertificateSearchParameters {
    id: number = 0;
    supplierID: number = 0;
    buyerID: number = 0;
    isSupplierZone: boolean = false;
    isBuyerZone: boolean = false;
}